import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {DeviceType} from '@gongxigames/framework/core';
import {AutoplayView} from '@gongxigames/framework/slot/modules/autoplay/AutoplayView';
import {AutoplayViewMobileLandscape} from '@gongxigames/framework/slot/modules/autoplay/AutoplayViewMobileLandscape';
import {AutoplayViewMobilePortrait} from '@gongxigames/framework/slot/modules/autoplay/AutoplayViewMobilePortrait';

export class AutoplayViewMobile extends AutoplayView {
    public static readonly NAME: symbol = Symbol('AutoplayViewMobile');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;

    protected _views: AutoplayView[] = [];

    private _landscapeView!: AutoplayView;
    private _portraitView!: AutoplayView;

    public init(): void {
        this.setupEvents();
        this.landscapeView = this._installer.getComponent<AutoplayView>(AutoplayViewMobileLandscape.NAME);
        this.portraitView = this._installer.getComponent<AutoplayView>(AutoplayViewMobilePortrait.NAME);
    }

    public onLandscape(): void {
        this._portraitView.hide();
        this._landscapeView.show();
    }

    public onPortrait(): void {
        this._landscapeView.hide();
        this._portraitView.show();
    }

    public setAutoplayFieldText(text: string): void {
        this._views.forEach((view: AutoplayView) => {
            view.setAutoplayFieldText(text);
        });
    }

    public hideAutoplayUI(): void {
        if (this._disabledAutoplayButton) {
            return;
        }

        this._views.forEach((view: AutoplayView) => {
            view.hideAutoplayUI();
        });
    }

    public showAutoplayUI(): void {
        if (this._disabledAutoplayButton) {
            return;
        }

        this._views.forEach((view: AutoplayView) => {
            view.showAutoplayUI();
        });
    }

    public stopAutoplayButtonClickAction(): void {
        this._views.forEach((view: AutoplayView) => {
            view.stopAutoplayButtonClickAction();
        });
    }

    public set landscapeView(value: AutoplayView) {
        this._landscapeView = value;
        this._landscapeView.parent = this.container;
        this._views.push(value);
    }

    public set portraitView(value: AutoplayView) {
        this._portraitView = value;
        this._portraitView.parent = this.container;
        this._views.push(value);
    }

    public get landscapeView(): AutoplayView {
        return this._landscapeView;
    }

    public get portraitView(): AutoplayView {
        return this._portraitView;
    }

    public get views(): AutoplayView[] {
        return this._views;
    }
}
